import { useTranslation } from 'react-i18next';
import { AccessTier } from 'services/api/models/UserDTO';
import PatientAccessTierIcon from './PatientAccessTierIcon';

const ACCESS_TIER_LABEL_KEYS: Record<AccessTier, string> = {
  LICENSE_CODE: 'chats.caregiverStatus.licenseCode',
  APP_SUBSCRIPTION: 'chats.caregiverStatus.paidSubscription',
  FREE: 'chats.caregiverStatus.freeTrial',
};

type PatientAccessTierTagProps = {
  accessTier: AccessTier;
  className?: string;
};

export default function PatientAccessTierTag({ accessTier, className }: PatientAccessTierTagProps) {
  const { t } = useTranslation();

  return (
    <span className={className}>
      <PatientAccessTierIcon accessTier={accessTier} />
      {t(ACCESS_TIER_LABEL_KEYS[accessTier])}
    </span>
  );
}
